import { useActor } from '@xstate/react';
import { ResidentView } from './ResidentView';
import { ResidentMachineActor } from '../../../machines/Eligibility/ResidentMachine';

export function ResidentController({ actor }: { actor: ResidentMachineActor }) {
  const [state, send] = useActor(actor);

  return <ResidentView state={state} send={send} />;
}
